/* import __COLOCATED_TEMPLATE__ from './nav-root-item.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { CAN_MANAGE_KNOWLEDGE_BASE_CONTENT } from 'embercom/lib/knowledge-hub/constants';
import { KNOWLEDGE_BLANK_QUERY_PARAMS } from 'embercom/lib/knowledge-hub/list-api';
import { type TreeItem } from 'embercom/objects/tree-list';
import type Router from '@ember/routing/router-service';

interface Args {
  item: TreeItem;
}

export default class NavRootItem extends Component<Args> {
  @service declare permissionsService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;
  @service declare router: Router;
  @tracked modalOpen = false;
  @service appService: any;

  get shouldShowUnifiedUi(): boolean {
    return this.appService.app.canUseUnifiedContentUI;
  }

  get blankQueryParams() {
    return KNOWLEDGE_BLANK_QUERY_PARAMS;
  }

  get isActive(): boolean {
    // Root folder is active when on all-content route WITHOUT native_content param
    return this.isOnAllContentRoute && !this.hasNativeContentParam;
  }

  get isOnAllContentRoute(): boolean {
    return this.router.currentRouteName === 'apps.app.knowledge-hub.all-content';
  }

  get hasNativeContentParam(): boolean {
    let param = this.router.currentRoute?.queryParams?.native_content;
    return param === 'true';
  }

  @action
  async openModal() {
    try {
      await this.permissionsService.checkPermission(CAN_MANAGE_KNOWLEDGE_BASE_CONTENT);
    } catch (e) {
      return;
    }

    this.modalOpen = true;
  }

  @action
  closeModal() {
    this.modalOpen = false;
  }

  @action
  toggleIsExpanded() {
    if (
      this.router.currentRouteName !== 'apps.app.knowledge-hub.all-content' ||
      this.router.currentRoute.queryParams.native_content !== undefined
    ) {
      return undefined;
    }
    this.args.item.isExpanded = !this.args.item.isExpanded;

    this.intercomEventService.trackAnalyticsEvent({
      action: this.args.item.isExpanded ? 'expanded' : 'collapsed',
      object: 'nav_root_item',
      place: 'knowledge-hub',
      section: 'content-section',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::Folders::Tree::NavRootItem': typeof NavRootItem;
    'knowledge-hub/folders/tree/nav-root-item': typeof NavRootItem;
  }
}
